export const scrollToElementByQuerySelector = (element:string) => {
    const container = document.querySelector(element);
    return container ? container.scrollIntoView({ behavior: 'smooth' }) : null;
}